import { z } from "zod";

import { BRAND_MARKUP } from "../../constants";
import { attachment } from "../shared";
import { defineModel } from "../types";

// Demucs pricing: ~$0.05 per minute of audio.
const COST_PER_SECOND_MICRODOLLARS = (0.05 / 60) * 1_000_000;

const replicateDemucsParams = z
  .object({
    model: z
      .enum(["htdemucs", "htdemucs_ft", "htdemucs_6s", "mdx_extra_q"])
      .optional(),
    attachments: z.array(attachment).optional(),
  })
  .strip();

export const replicateDemucs = defineModel({
  key: "replicate-demucs",
  stepType: "voice-extract",
  spec: {
    label: "Demucs Voice Isolation",
    description:
      "Split audio into voice and instrumental tracks using Demucs on Replicate.",
    icon: "replicate-icon.svg",
    tags: ["replicate", "voice-extract"],
    features: { attachments: true } as const,
    options: {
      attachments: [
        {
          type: "media",
          label: "Audio or Video",
          slot: "media",
          required: true,
          allowedFormats: [
            "audio/wav",
            "audio/mp3",
            "audio/mpeg",
            "audio/m4a",
            "audio/ogg",
            "video/mp4",
            "video/quicktime",
            "video/webm",
          ],
        },
      ],
    },
    params: replicateDemucsParams,
  },
  providers: [
    {
      provider: "replicate",
      modelId: "ryan5453/demucs",
      estimateCost(_params) {
        const estimatedDurationSeconds = 60;
        return Math.round(
          estimatedDurationSeconds *
            COST_PER_SECOND_MICRODOLLARS *
            (1 + BRAND_MARKUP),
        );
      },
      toPayload(params) {
        return {
          model: params.model,
        };
      },
    },
  ],
});
